import { useReducer } from 'react'
import type { ReactNode } from 'react'
import {
  CommonStateChangerContext,
  CommonStateContext,
  initialState,
} from './context'

import commonReducer from './common-reducer'

export default function CommonStateProvider({
  children,
}: {
  children: ReactNode
}) {
  const [commonState, commonStateDispatch] = useReducer(
    commonReducer,
    initialState,
  )

  return (
    <CommonStateContext.Provider value={commonState}>
      <CommonStateChangerContext.Provider value={commonStateDispatch}>
        {children}
      </CommonStateChangerContext.Provider>
    </CommonStateContext.Provider>
  )
}
